import React from "react";
import {SupplierDashboard} from "./SupplierDashboard";


export function SupplierDashboardPage() {
    return <SupplierDashboard />;
}
